import React from "react";
import AdmDocumentUpload from "../../components/AdminTabs/AdminDocumentUpload/AdmDocumentUpload";

const AddStudent = () => {
  return (
    <div>
      <AdmDocumentUpload/>
    </div>
  );
};

export default AddStudent;
